import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  max-width: 400px;
  margin: 64px auto;
  background: #fff;
  border-radius: 24px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  padding: 40px 32px;
  text-align: center;
`;

const InsightsList = styled.div`
  margin: 18px 0 24px 0;
  font-weight: 600;
  color: #222;
`;

const SignUpButton = styled.button`
  padding: 14px 32px;
  border-radius: 24px;
  background: #FFD166;
  color: #222;
  font-weight: 600;
  border: none;
  margin-top: 16px;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background 0.2s;
  &:hover, &:focus { background: #ffe299; }
`;

export default function SignUpTeaser({ insights = [], onSignUp }) {
  return (
    <Wrapper>
      <h2>Your Unique Insights Are Ready</h2>
      <p>
        We've analyzed your answers and found interesting patterns in:
      </p>
      <InsightsList>
        {insights.length > 0
          ? insights.map(i =>
              i.charAt(0).toUpperCase() + i.slice(1)
            ).join(", ")
          : "No insights found"}
      </InsightsList>
      <p>
        <strong>Sign up to unlock your personalized roadmap and tools!</strong>
      </p>
      <SignUpButton onClick={onSignUp}>
        Sign Up to See My Roadmap
      </SignUpButton>
    </Wrapper>
  );
}
